import React, { forwardRef } from 'react'
import autosize from 'autosize'
import { Textarea } from '@chakra-ui/react'

interface Props {
    value: string
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
    placeholder: string
    onPaste?: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

const InputTextarea = forwardRef<HTMLTextAreaElement, Props>(
    ({ value, onChange, placeholder, onPaste, onKeyDown }, ref) => {
        return (
            <Textarea
                ref={ref}
                variant="unstyled"
                placeholder={placeholder}
                fontSize="sm"
                borderWidth={0}
                value={value}
                onChange={onChange}
                onPaste={onPaste}
                onKeyDown={onKeyDown}
                px={3}
                py={3}
                resize="none"
                minHeight="32px"
                onFocus={e => {
                    autosize(e.target)
                }}
                onBlur={e => {
                    autosize.destroy(e.target)
                }}
            />
        )
    },
)

export default InputTextarea
